<template>
	<div class="course">
		<div v-if="banner && banner.length" class="course-banner">
            <img :src="img.logo" v-for="img in banner" :key="img.logo" alt="" @click="openBanner(img.url)">
        </div>
		<div class="course-body">
			<div v-if="courseList.length">
				<course-list 
					:course-list="courseList" 
					:loading="scrollLoading"
					:page-size="pageSize" 
					:page-num="pageNum" 
					:total="total"
					@page-change="handlePageChange"
				/>
			</div>
			<EmptyPage v-else :height="480" :loading="loading" />
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import debounce from "lodash/debounce";
import EmptyPage from "@/components/EmptyPage";
import CourseList from "@/components/CourseList";
import { getCourseList } from "@/api/courses";
import { getBannerURL } from "@/api/common";

export default {
	name: "Courses",
	inject: ["checkToken", "backTop"],
	components: {
		EmptyPage,
		CourseList
	},
	data(){
		return {
			loading: true,
			scrollLoading: false,
			total: 0,
			pageSize: 20,
			pageNum: sessionStorage.getItem(this.$route.path) || 1,
			pages: 1,
			courseList: [],
			banner: null,
		}
	},
	created() {
		this.getCourseList();
		this.getBannerURL()
	},
	computed: {
		...mapState("app", ["scrollStatus"]),
	},
	watch: {
		// scrollStatus() {
		// 	if (!this.user && !this.scrollLoading) {
		// 		this.scroll();
		// 	}
		// },
	},
	methods: {
		openBanner(imgUrl) {
            window.open(imgUrl);
        },
        // 获取banner图地址
        getBannerURL() {
            getBannerURL(6).then(({ data }) => {
                this.banner = (data || []).splice(0,2);
            });
        },
		// 无限滚动
		scroll() {
			if (this.pageNum > 100) return;
			if (this.pageNum >= this.pages) return;
			this.scrollLoading = true;
			this.pageNum++;
			this.getCourseList();
		},
        handlePageChange(pageNum) {
			sessionStorage.setItem(this.$route.path, pageNum)
            this.pageNum = pageNum;
            this.backTop();
            this.getCourseList();
        },
		getCourseList() {
			getCourseList({
				pageNum: this.pageNum,
				pageSize: this.pageSize,
			})
				.then(({ data }) => {
                    this.courseList = data.result || []
					this.total = data.total;
					this.pages = data.pages;
				})
				.finally(() => {
					this.loading = false;
					this.scrollLoading = false;
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.course {
	font-family: Microsoft YaHei;
	margin: 0 auto;
    background: #f5f6f9;
	&-banner {
        // padding: 20px 0;
        // background-color: #fff;
        text-align: center;
        font-size: 0;
		display: flex;
		padding: 20px 0 0 0;
		width: 1600px;
		overflow: hidden;
		margin: 0 auto;
        > img {
            cursor: pointer;
            flex:1;
			margin-right: 20px;
			border-radius: 4px;
			height: 120px;
            font-size: 0;
			width: 790px;
			&:nth-last-child(1) {
				margin-right: 0;
			}
        }
    }
    &-body {
        margin: 0 auto;
        width: 1400px;
    	// padding: 30px 0;
    }
}

@include mq($small) {
	.course {
		&-body {
			width: 1200px;
		}
	}
}
</style>